import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';

export default class EudrDeclarationService {
    static getInstance() {
        if (!EudrDeclarationService.instance) {
            EudrDeclarationService.instance = new EudrDeclarationService();
        }

        return EudrDeclarationService.instance;
    }

    async list(supplierId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/supplier/products/eudr`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data || null;
    }

    async searchByIds(supplierId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/supplier/products/eudr/by-ids`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data?.data || null;
    }

    async declare(payload) {
        const response = await axios.put(`${API_BASE_URL}/supplier/product/dds-declaration`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data?.data || null;
    }

    async finalize(reportId, payload) {
        const response = await axios.post(`${API_BASE_URL}/report/${reportId}/submit`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        })

        return response.data|| null;
    }
}
